import React from 'react';
import LandingTemplate from '~/templates/LandingV2';
import { Translation } from '~/components/Translation';

import PropTypes from 'prop-types';

const Landing = ({ isLogoExperimentVariant }) => (
	<LandingTemplate
		isLogoExperimentVariant={isLogoExperimentVariant}
		heading={<Translation tid="landing.title" />}
		subHeading={<Translation tid="landing.subtitle.v2" />}
	/>
);

Landing.propTypes = {
	isLogoExperimentVariant: PropTypes.bool,
};

export default Landing;
